<template>
     <section id="hero">
          <v-carousel height="minHeight" hide-delimiters>
               <v-carousel-item
                    v-for="(item, i) in items"
                    :key="i"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
               >
                    <v-img
                         :min-height="minHeight"
                         :src="item.src"
                         class="white--text"
                         gradient="to right, rgba(5, 11, 31, .4), rgba(5, 11, 31, .4)"
                    >
                         <v-container class="fill-height px-4 py-12">
                              <v-responsive
                                   class="d-flex align-center text-center"
                                   height="100%"
                                   max-width="100%"
                                   width="100%"
                              >
                                   <base-heading
                                        title="PROMOTE YOUR BUSINESS WITH ZERO"
                                        align="center"
                                   />

                                   <v-row>
                                        <v-col
                                             cols="12"
                                             md="8"
                                             sm="8"
                                             offset-md="2"
                                        >
                                             <base-body
                                                  align="center"
                                                  class="text-center"
                                             >
                                                  Infographic hypotheses
                                                  influencer user experience
                                                  Long madel ture gen-z paradigm
                                                  shift client partner network
                                                  product seilans solve
                                                  management influencer
                                                  analytics leverage virality.
                                                  incubator seed round
                                                  massmarket. buyer agile
                                                  development growth hacking
                                                  business-to-consumer ecosystem
                                             </base-body>
                                             <base-btn>
                                                  Discover More
                                             </base-btn>

                                             <span
                                                  class="font-weight-bold ml-6 mr-4 my-4"
                                                  >or</span
                                             >

                                             <base-btn
                                                  :ripple="false"
                                                  class="pa-1"
                                                  height="auto"
                                                  text
                                             >
                                                  Get Started Now
                                             </base-btn>
                                        </v-col>
                                   </v-row>

                                   <div
                                        :class="
                                             $vuetify.breakpoint.smAndDown
                                                  ? 'flex-column align-start'
                                                  : 'align-center'
                                        "
                                        class="d-flex flex-wrap"
                                   ></div>
                              </v-responsive>
                         </v-container>
                    </v-img>
               </v-carousel-item>
          </v-carousel>
     </section>
</template>

<script>
export default {
     name: 'SectionHeroSlider',

     provide: {
          theme: { isDark: true },
     },

     computed: {
          minHeight() {
               const height = this.$vuetify.breakpoint.mdAndUp
                    ? '100vh'
                    : '50vh'

               return `calc(${height} - ${this.$vuetify.application.top}px)`
          },
     },
     data: () => ({
          items: [
               {
                    src: '/assets/images/placeholder.gif',
               },
               {
                    src: '/assets/images/placeholder.gif',
               },
               {
                    src: '/assets/images/placeholder.gif',
               },
          ],
     }),
}
</script>
